import Helper from "./Helper";
import Swiper from "swiper/bundle";

class SliderHandler {
  constructor(config = {}) {
    const {
      sliderType,
      outerWrapperSelector,
      sliderContainerSelector,
      sliderPaginationselector,
      sliderPrevSelector,
      sliderNextSelector,
      sliderBreakpoint,
    } = config;
    this.sliderType = sliderType;
    this.outerWrapperSelector = outerWrapperSelector;
    this.sliderContainerSelector =
      sliderContainerSelector || ".swiper-container";
    this.sliderPaginationselector =
      sliderPaginationselector || ".swiper-pagination";
    this.sliderPrevSelector = sliderPrevSelector || ".swiper-button-prev";
    this.sliderNextSelector = sliderNextSelector || ".swiper-button-next";
    this.sliderBreakpoint = sliderBreakpoint || 768;

    this.sliders = document.querySelectorAll(this.outerWrapperSelector);
    this.slidersArray = Array.prototype.slice.call(this.sliders);

    this.currentScreenWidth = window.innerWidth;
    this.previousScreenWidth = window.innerWidth;
    this.sliderIsInitiated = false;
    this.currentlyDesktop = "";
    this.swiperInstances = [];

    if (this.sliders) {
      this.bindEvents();
    }
  }

  bindEvents() {
    if (this.currentScreenWidth < this.sliderBreakpoint) {
      this.currentlyDesktop = false;
      this.initSwipersMobile();
    } else {
      this.currentlyDesktop = true;
      this.initSwipersDesktop();
    }

    window.addEventListener("resize", () => {
      const vw = window.innerWidth;

      // console.log(this.currentlyDesktop);

      if (this.previousScreenWidth < this.sliderBreakpoint) {
        if (vw > this.sliderBreakpoint) {
          // console.log("breakpoint change");
          this.destroySwipers();
          this.initSwipersDesktop();
        }
      }

      if (this.previousScreenWidth > this.sliderBreakpoint) {
        if (vw < this.sliderBreakpoint) {
          // console.log("breakpoint change");
          this.destroySwipers();
          this.initSwipersMobile();
        }
      }

      this.previousScreenWidth = vw;
    });
  }

  initSwipersDesktop() {
    // console.log("desktop");
    this.slidersArray.forEach((slider, index) => {
      const swiperContainer = slider.querySelector(
        this.sliderContainerSelector
      );
      let swiperConfig = {};
      if (this.sliderType == "header") {
        // console.log("header");
        const swiperNav = [];
        const slides = Array.prototype.slice.call(
          slider.querySelectorAll(".swiper-slide")
        );
        slides.forEach((slide, index) => {
          const slideInfo = [];
          slideInfo.title = slide.querySelector(
            ".slide-pagination-title"
          ).innerText;
          slideInfo.subtitle = slide.querySelector(
            ".slide-pagination-subtitle"
          ).innerText;
          swiperNav["slide-" + index] = slideInfo;
        });
        swiperConfig = {
          speed: 600,
          parallax: true,
          loop: true,
          autoplay: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
              return (
                `<span class="${className} custom-pagination-bullet">
                  <span class="subtitle">${swiperNav["slide-" + index].subtitle}</span>
                  <span class="title">${swiperNav["slide-" + index].title}</span>
                </span>`
              );
            },
          },
        };
      }
      if(this.sliderType == 'articles') {
        swiperConfig = {
          slidesPerView: 'auto',
          spaceBetween: 30,
          speed: 600,
          parallax: true,
          centeredSlides: false,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        };
      }
      const instance = new Swiper(swiperContainer, swiperConfig);
      this.swiperInstances.push(instance);
    });
  }

  initSwipersMobile() {
    // console.log("mobile");
    this.slidersArray.forEach((slider, index) => {
      const swiperContainer = slider.querySelector(
        this.sliderContainerSelector
      );
      let swiperConfig = {};
      if (this.sliderType == "header") {
        swiperConfig = {
          speed: 600,
          parallax: true,
          loop: true,
          autoplay: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            // dynamicBullets: true,
          },
        };
      }
      if(this.sliderType == 'articles') {
        swiperConfig = {
          speed: 600,
          parallax: true,
          slidesPerView: 'auto',
          spaceBetween: 25,
          centeredSlides: false,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            // dynamicBullets: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        };
      }
      const instance = new Swiper(swiperContainer, swiperConfig);
      this.swiperInstances.push(instance);
    });
  }

  destroySwipers() {
    // console.log(this.swiperInstances);
    // console.log("destroy");
    this.swiperInstances.forEach((instance) => {
      instance.destroy(true, true);
    });
  }
}

export default SliderHandler;
